export default {
	trackByISRC: (isrc: string) => `/track/${isrc}`,
};
